<template>
  <div class="vl-parent">
    <loading v-model:active="carregando" color="red" loader="dots" />
  </div>
  <v-app>
    <NavBar />
  </v-app>
</template>

<script>
import NavBar from "./components/navBar.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { mapGetters } from "vuex";
import { computed } from 'vue'
import { useIdle, useTimestamp } from '@vueuse/core'

export default {
  name: "App",
  data() {
    return {
      fullPage: true,
    };
  },
  watch:{
    idle(n){
      if(n == true){
        window.location.reload()
      }
    }
  },
  setup() {
    const { idle, lastActive } = useIdle(90000)
    const now = useTimestamp({ interval: 1000 })

    const idledFor = computed(() => {
      return Math.floor((now.value - lastActive.value) / 1000)
    })

    return {
      idle,
      idledFor,
    }
  },
  components: {
    NavBar,
    Loading,
  },
  computed: {
    ...mapGetters(["carregando"]),
    
  },
  methods: {},
  created() {
    
  },
};
</script>

<style>
::-webkit-scrollbar {
  width: 10px;
  border: solid 20px white;
  border-radius: 25px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(171, 171, 171);
  border: solid 2px white;
  border-radius: 25px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(155, 153, 153);
}
@keyframes slide {
  from {
    left: 100%;
  }
  to {
    left: -100%;
  }
}
@-webkit-keyframes slide {
  from {
    left: 100%;
  }
  to {
    left: -100%;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body,
html {
}
.vl-overlay .vl-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  opacity: 0.5;
}
</style>
